<script setup>
import {onMounted, ref} from "vue"
import helpers from "@/lib/helpers";

const emits = defineEmits(['submit'])
const props = defineProps({
  embedded: Boolean,
  formatter: {
    type: Object,
    required: true
  },
  formatterKey: {
    type: String,
    required: true
  },
  url: {
    type: String,
    required: true
  },
  options: Object,
  q: {
    type: String,
    default: null
  }
})

const query = ref(props.q)
const items = ref(null)

const reset = () => {
  query.value = null
  items.value = null
  search()
}

const search = (refresh) => {
  helpers.asyncAction(props.url, 'GET', {
    data: {
      q: query.value,
      filter: !query.value ? 'history' : null,
      ...props.options,
      limit: 100
    }
  }).then(response => {
    if ((response.length == 1) && response[0]._exact)
      select(response[0])
    else if (response.length > 0) {
      items.value = response
      /*
      if (this.item) {
        const found = this.items.find((f) => f.id == this.item.id)
        if (!found)
          this.reset()
        else
          this.select(found)
      }
    } else {
      reset()
       */
    }
  })
}

const select = (i) => {
  emits('submit', i)
}

onMounted(reset)
</script>

<template>
  <component :is="embedded ? 'div' : 'modal'" title="Selector" height="400px">
    <modal-portal to="top">
      <b-input-group>
        <template #prepend>
          <b-input-group-text>
            <font-awesome-icon icon="fa-solid fa-magnifying-glass fa-2x"/>
          </b-input-group-text>
        </template>
        <b-input @keyup.enter="search()" autofocus size="sm" v-model="query"/>
        <b-input-group-append>
          <b-button v-if="!!query" @click="reset" size="sm" variant="outline-secondary">X</b-button>
          <b-button @click="search()" variant="primary" size="sm">Search</b-button>
        </b-input-group-append>
      </b-input-group>
    </modal-portal>

    <b-list-group v-if="!!items">
      <template v-if="items.length">
        <b-list-group-item action @click="select(i)" v-for="i in items" :key="i.gli">
          <component :is="formatter" v-bind="{[formatterKey]: i}"/>
        </b-list-group-item>
      </template>
      <b-list-group-item v-else>
        No Results
      </b-list-group-item>
    </b-list-group>

  </component>
</template>


<style scoped>

</style>